/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.breeze.engine.rpc.BreezeEngineAgentsService
 */

export const BreezeAgentToolTypename = 'com.hubspot.breeze.engine.data.models.BreezeAgentTool';
export const BreezeAgentToolDiscriminant = 'AGENT';
export const BreezeAgentToolDiscriminantKey = 'type';
export const BreezeChirpToolTypename = 'com.hubspot.breeze.engine.data.models.BreezeChirpTool';
export const BreezeChirpToolDiscriminant = 'CHIRP';
export const BreezeChirpToolDiscriminantKey = 'type';
export const BreezeEngineToolDiscriminantKey = 'type';
export const BreezeKnowledgeVaultToolTypename = 'com.hubspot.breeze.engine.data.models.BreezeKnowledgeVaultTool';
export const BreezeKnowledgeVaultToolDiscriminant = 'KNOWLEDGE_VAULT';
export const BreezeKnowledgeVaultToolDiscriminantKey = 'type';
export const listAgentsRpc = {
  serviceName: 'com.hubspot.breeze.engine.rpc.BreezeEngineAgentsService',
  rpcName: 'listAgents',
  auth: 'app',
  fingerprint: 'TUomi6rvl9SngRSKPulCR1J8GnIfkswz',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};